function defaultApiBase() {
  const { protocol, hostname, port } = window.location;
  const isDevHost = hostname === 'localhost' || hostname === '127.0.0.1' || /^10\.\d+\.\d+\.\d+$/.test(hostname);
  const isViteDev = isDevHost && port && port !== '3010';
  if (isViteDev) {
    const apiPort = window.__HERMES_DEV_API_PORT__ || '8000';
    return `${protocol}//${hostname}:${apiPort}/api`;
  }
  return '/api';
}

export const API = defaultApiBase().replace(/\/$/, '');

export function apiUrl(path = '') {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return `${API}${normalized}`;
}

export function authHeaders(extra = {}) {
  const token = localStorage.getItem('token');
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}
